import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import HeroSection from '../../components/home/heroSection/heroSection';
import SummerCampSection from '../../components/home/summerCampSection/summerCampSection';
import SixYardExperience from '../../components/home/sixYardExperience/sixYardExperience';
import Services from '../../components/home/services/services';
import Academy from '../../components/home/academySection/academySection';
import LoyaltyProgram from '../../components/home/loyaltyProgramSection/loyaltyProgramSection';
import DownloadApplication from '../../components/home/downloadApplication/downloadApplication';
import PromptMessage from '../../components/containers/promptMessage/promptMessage';
import CampRegistrationForm from '../../components/camps/campRegistrationForm/campRegistrationForm';
import ParallaxRectangle from '../../components/containers/parallaxRectangle/parallaxRectangle';
import LoginModal from '../../components/containers/loginModal/loginModal';

const Home = (props) => {    
    const location = useLocation();
    const [showPrompt, setShowPrompt] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [showLoginForm, setShowLoginForm] = useState(false);

    useEffect(() => {
        if (location.state?.from === '/register') {
            setShowPrompt(true);
        }
    }, [location]);
    useEffect(() => {
        props.isAuthenticated && setShowLoginForm(false);
    }, [props.isAuthenticated])
    const handleOkClick = () => {
        setShowPrompt(false); // Close the prompt
    };

    return (
        !showForm ? <div>
            {/* <ParallaxRectangle /> */}
            <HeroSection heroSection={props.heroSection} />
            <SummerCampSection heroSection={props.heroSection} pricingPackages={props.pricingPackages}
            setSelectedPlan={setSelectedPlan} setShowForm={setShowForm} camp={"Summer"||"Winter"||"Football"}/>
            <SixYardExperience experienceSection={props.pageSections.filter(section => section.section_key === "experience")[0]}
            services={props.features.filter(feature => feature.category === "services")}
            isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>
            <Services serviceSection={props.pageSections.filter(section => section.section_key === "services")[0]}
            featuredActivities={props.featuredActivities} isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>
            <Academy academySection={props.pageSections.filter(section => section.section_key === "academy")[0]}/>
            <LoyaltyProgram loyaltySection={props.pageSections.filter(section => section.section_key === "loyalty")[0]}
                isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>
            <DownloadApplication appSection={props.pageSections.filter(section => section.section_key === "app")[0]}
            app={props.app}/>
            {showPrompt && (
                <PromptMessage status='CONGRATULATIONS' click={handleOkClick}
                    message='Email verified successfully' button='CLOSE' successMessage />
            )}
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} currentPath={'/field-booking'} />}
        </div>
        : <CampRegistrationForm setShowCampRegistrationForm={setShowForm}
        selectedPlan={selectedPlan}
        camp={"Summer"||"Winter"||"Football"}
    />
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.token !== null,
});
export default connect(mapStateToProps)(Home);